import { datadogRum } from '@datadog/browser-rum';

import type { MonitoringConfig, MonitoringRUM } from '../types';
import { getTracingURLs } from './getTracingURLs';

interface BrowserRumProps extends MonitoringConfig, MonitoringRUM {}

let DD_RUM_INITIALIZED = false;

const ERROR_LOG_BLOCKED_DOMAINS = [
  'taboola.com',
  'hotjar.com',
  'smct.co',
  'tiktok.com',
  'bing.com',
];

const containsBlockedDomain = (url: string) => {
  return ERROR_LOG_BLOCKED_DOMAINS.some((domain) => url.includes(domain));
};

const configurationBrowserRum = ({
  applicationId,
  clientToken,
  featureFlags = {},
  monitoringEnv,
  rumSampleRate,
  rumTracingURLs,
  serviceName,
  version,
}: BrowserRumProps) => {
  datadogRum.init({
    clientToken: clientToken,
    applicationId: applicationId,
    site: 'datadoghq.com',
    env: monitoringEnv,
    service: serviceName,
    version: version,
    enableExperimentalFeatures: [featureFlags ? 'feature_flags' : ''],
    sessionSampleRate: rumSampleRate,
    sessionReplaySampleRate: rumSampleRate,
    traceSampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    allowedTracingUrls: getTracingURLs(rumTracingURLs),
    defaultPrivacyLevel: 'allow',
    beforeSend: (event) => {
      if (
        event.type === 'resource' &&
        event.resource &&
        containsBlockedDomain(event.resource.url)
      ) {
        return false;
      }

      if (
        event.type === 'error' &&
        event.error &&
        event.error.stack &&
        containsBlockedDomain(event.error.stack)
      ) {
        return false;
      }

      return true;
    },
  });
  Object.entries(featureFlags).map(([name, value]) =>
    datadogRum.addFeatureFlagEvaluation(name, JSON.stringify(value)),
  );
};

export const BrowserRum = (props: BrowserRumProps) => {
  if (!DD_RUM_INITIALIZED) {
    configurationBrowserRum(props);
    DD_RUM_INITIALIZED = true;
  }

  return null;
};
